import axios from 'axios';
import errorHandlerFactory from './errorHandler';
import { filterSummaries } from './adapters/csaImpactAdapter';
import { loadTradesIntoPricingParams } from './adapters/pricingParametersSubmit';

const errorHandler = errorHandlerFactory('An error occured when booking trades.');
const getTradeErrorHandler = errorHandlerFactory('An error occured fetching trade information.');

// eslint-disable-next-line import/prefer-default-export
export const tradePricedTodayRequest = params => axios.post('/CsaImpact/UpdatedTradeSelectionComp', params)
    .then(r => filterSummaries(r.data)).catch(errorHandler);

export const getTradeInfo = (tradeId, date, csa) => axios.get(`/csaimpact/GetCsaTradeDetails?runDate=${date}&csa=${csa}&tradeid=${tradeId}`)
    .then(r => loadTradesIntoPricingParams(r.data)).catch(getTradeErrorHandler);
